module.exports = __webpack_public_path__ + "static/media/sort_asc.bf1bae37.png";